site.accessibility = {
	init:function() {
		$('#header .logo a').attr('tabindex', '1');
		$('#mainmenu a').attr('tabindex', '2');
		$('#qn a').attr('tabindex', '3');
		$('#custom-hero .owl-item.active a').attr('tabindex', '4');
		$('#custum-hero .owl-dots > div').attr('tabindex', '5');
		$('#quickBox a').attr('tabindex', '6');
		$('.addthis_toolbox a').attr('tabindex', '-1');

		$("#header .logo a").attr("accesskey", "h");

		$(document).keydown(function (e) {
			if (e.which == 9) {
				$('body').addClass('tabbing');
			}
			else if (e.which == 27 && $('body').hasClass('megamenu-open')) {
				site.megamenu.close();
			}
		});
		$(document).mousedown(function (e) {
			$('body').removeClass('tabbing');
		});
	}
};